import { createSlice } from '@reduxjs/toolkit'
import {
  setFileUploaded,
  removeFileUploaded,
  setFileProcessing,
  setFilePending,
  setIsUploadDone
} from './action'

const courseSlice = createSlice({
  name: 'course',
  initialState: {
    data: null,
    pendingFileList: [],
    processingFile: {},
    uploadedFileList: [],
    isUploadDone: false
  },

  reducers: {
    resetState: (state) => {
      state.data = null
      state.pendingFileList = []
      state.processingFile = {}
    }
  },
  extraReducers: (builder) => {
    builder.addCase(setFileUploaded, (state, action) => {
      const { file } = action.payload
      state.isUploadDone = false
      state.uploadedFileList = [...state.uploadedFileList, action.payload]

      const filesFilter = state.pendingFileList.filter((x) => x !== file)
      state.pendingFileList = filesFilter
    })
    builder.addCase(removeFileUploaded, (state, action) => {
      state.uploadedFileList = state.uploadedFileList.filter(
        ({ file }) => file.name !== action.payload
      )
    })
    builder.addCase(setFileProcessing, (state, action) => {
      state.processingFile = action.payload

      const filesFilter = state.pendingFileList.filter((x) => x !== action.payload.file)
      state.pendingFileList = filesFilter
    })
    builder.addCase(setFilePending, (state, action) => {
      const prevFiles = state.pendingFileList
      const { files, data } = action.payload

      if (prevFiles.length > 0) {
        const data = prevFiles.concat(files)
        state.pendingFileList = data
      } else {
        state.pendingFileList = files
      }
      state.data = data
    })
    builder.addCase(setIsUploadDone, (state, action) => {
      state.isUploadDone = action.payload
    })
  }
})

export default courseSlice

export const { resetState } = courseSlice.actions
